import React from "react";
import {
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { BarChart } from "@mui/x-charts";

interface BarChartCardDashboardProps {
  title: string;
  xAxisData: string[];
  seriesData: (number[] | { data: number[];})[];
  colors: string[];
  height: number;
  subtitle: string;
  subtitleY: string;
  subtitleX: string;
  subtitle2: string;
}

export default function BarChartCardDashboard({
  title,
  xAxisData,
  seriesData,
  colors,
  height,
  subtitleY,
  subtitle,
  subtitleX,
  subtitle2,
}: BarChartCardDashboardProps) {
  return (
    <CardContent sx={{ padding: 0, marginTop: 2 }}>
      <Stack spacing={3} p={1}>
        <Card elevation={4} sx={{ padding: 2 }}>
          <Typography variant="button" fontWeight={600} fontSize={20}>
            {title}
          </Typography>
          <Divider sx={{ width: "120%", marginLeft: -2, mt: 1 }} />
          <CardContent>
            <div style={{ width: "100%", height: "100%" }}>
              <BarChart
                xAxis={[{ scaleType: "band", data: xAxisData }]}
                series={seriesData.map((item) =>
                  Array.isArray(item) ? { data: item} : item
                )}
                colors={colors}
                height={height}
              />
            </div>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid
              container
              direction={{ xs: "column", sm: "column", md: "row" }}
              justifyContent="center"
              alignItems="center"
              spacing={10}
            >
              <Grid item>
                <Grid container direction="column" alignItems="center">
                  <Typography variant="h5" fontWeight={600}>
                    {subtitleY}
                  </Typography>
                  <Typography
                    variant="button"
                    fontWeight={400}
                    sx={{ textTransform: "uppercase" }}
                  >
                    {subtitle}
                  </Typography>
                </Grid>
              </Grid>

              <Grid item>
                <Grid container direction="column" alignItems="center">
                  <Typography
                    variant="h5"
                    mt={{ xs: 3, sm: 0, md: 0 }}
                    fontWeight={600}
                  >
                    {subtitleX}
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight={400}
                    sx={{ textTransform: "uppercase" }}
                  >
                    {subtitle2}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Stack>
    </CardContent>
  );
}
